// Utility functions for AdminV2 components
import { parseUTCDate } from '@utils/dateUtils';

export function formatDateTime(dateString: string | Date | null | undefined): string {
  if (!dateString) {
    return 'N/A';
  }
  const date = parseUTCDate(dateString);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  return date.toLocaleString();
}

export function formatRelativeTime(dateString: string | Date | null | undefined): string {
  if (!dateString) {
    return 'N/A';
  }
  const date = parseUTCDate(dateString);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return 'Just now';
  if (diffInSeconds < 3600) return `${String(Math.floor(diffInSeconds / 60))} minutes ago`;
  if (diffInSeconds < 86400) return `${String(Math.floor(diffInSeconds / 3600))} hours ago`;
  if (diffInSeconds < 2592000) return `${String(Math.floor(diffInSeconds / 86400))} days ago`;
  return date.toLocaleDateString();
}

export function getStatusColor(status: string | undefined | null): string {
  if (!status) {
    return 'bg-gray-100 text-gray-800';
  }

  switch (status.toLowerCase()) {
    case 'completed':
    case 'success':
    case 'active':
      return 'bg-green-100 text-green-800';
    case 'pending':
    case 'processing':
      return 'bg-yellow-100 text-yellow-800';
    case 'failed':
    case 'error':
    case 'cancelled':
      return 'bg-red-100 text-red-800';
    case 'draft':
    case 'inactive':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-blue-100 text-blue-800';
  }
}

export function getStatusBadgeColor(
  status: string | undefined | null,
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  if (!status) return 'default';

  switch (status.toLowerCase()) {
    case 'completed':
    case 'success':
    case 'active':
      return 'success';
    case 'pending':
    case 'processing':
      return 'warning';
    case 'failed':
    case 'error':
    case 'cancelled':
      return 'error';
    case 'draft':
    case 'inactive':
      return 'secondary';
    default:
      return 'primary';
  }
}

export function formatCents(cents: number | undefined | null): string {
  if (cents == null) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

export function formatPercent(pct: number | undefined | null): string {
  if (pct == null) return '-';
  return `${pct.toFixed(1)}%`;
}

export function getStalenessColor(days: number | undefined | null): string {
  if (days == null) return 'text-gray-400';
  if (days < 7) return 'text-green-600';
  if (days <= 14) return 'text-yellow-600 font-medium';
  return 'text-red-600 font-bold';
}
